<template>
  <div class="marker-action">
    <list-action-form
      ref="form"
      :ids="ids"
      :labels="labels"
      :route="route"
      :method="method"
      @submitted="confirmSubmit"
    >
    </list-action-form>
    <modal
      v-model="showModal"
      :title="labels.confirmModalTitle"
      :header="false"
      :confirm-button-label="labels.ok"
      :close-button-label="labels.cancel"
      @closed="showModal = false"
      @confirmed="submit"
    >
      <button
        id="close"
        slot="before-content"
        @click.prevent="showModal = false"
      >
        <i class="af-icons af-icons-cross"></i>
      </button>
      {{ modalBody }}
    </modal>
  </div>
</template>

<script>
import ListAction from './ListAction.vue';
import { Modal } from 'vue-bootstrap';

/**
 * The Archiver component.
 */
export default {
  components: {
    Modal
  },
  extends: ListAction,
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    modalBody() {
      const id =
        this.ids.length > 1 ? 'alerts-archive-items' : 'alerts-archive-item';
      const element = document.getElementById(id);
      return element ? element.textContent : '';
    }
  },
  methods: {
    confirmSubmit() {
      this.showModal = true;
    }
  }
};
</script>
